import { Star } from "lucide-react";

const LABELS = ["Poor", "Fair", "Good", "Very good", "Excellent"];
const N = [1, 2, 3, 4, 5];

export const OverallRating = ({ value, onChange }) => (
  <div>
    <div className="grid grid-cols-5 gap-2 sm:gap-3">
      {N.map((n) => {
        const on = value >= n;
        return (
          <button
            type="button"
            key={n}
            data-testid={`survey-overall-star-${n}`}
            aria-label={`${n} star${n > 1 ? "s" : ""}`}
            onClick={() => onChange(n)}
            className={`aspect-square rounded-2xl border-2 grid place-items-center transition-[transform,background-color,border-color] duration-150 active:scale-90 ${
              on ? "border-amber-400 bg-amber-50" : "border-slate-200 bg-white hover:border-amber-300"
            } ${value === n ? "scale-105" : ""}`}
          >
            <Star className={`w-7 h-7 sm:w-8 sm:h-8 transition-colors ${on ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
          </button>
        );
      })}
    </div>
    <p className="mt-3 text-center text-sm font-semibold h-5 text-[#4B5A54]" data-testid="survey-overall-label">
      {value ? LABELS[value - 1] : "Tap a star to rate"}
    </p>
  </div>
);

export const CategoryRating = ({ label, value, onChange, testId }) => (
  <div data-testid={testId} className="flex items-center justify-between gap-3 py-2.5">
    <span className="text-sm sm:text-base font-medium text-[#1A2B25]">{label}</span>
    <div className="flex gap-0.5">
      {N.map((n) => (
        <button
          type="button"
          key={n}
          data-testid={`${testId}-${n}`}
          aria-label={`${label} ${n}`}
          onClick={() => onChange(n)}
          className="p-1.5 rounded-lg transition-transform duration-150 hover:scale-110 active:scale-90"
        >
          <Star className={`w-6 h-6 ${value >= n ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
        </button>
      ))}
    </div>
  </div>
);

export const StarDisplay = ({ value, size = "w-4 h-4" }) => (
  <div className="flex gap-0.5" aria-label={`${value} out of 5`}>
    {N.map((n) => (
      <Star key={n} className={`${size} ${value >= n ? "fill-amber-400 text-amber-400" : "text-slate-200 fill-slate-200"}`} />
    ))}
  </div>
);
